module.exports = __webpack_public_path__ + "img/side seam.e1f8e50f.png";